import React from "react";
import banner1 from "../assets/images/banner_1.jpg";
import testimonialimg from "../assets/images/university.png";
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../assets/css/style.css"

const Aggregators = () => {
    return (
        <div>
            <div class="banner-one banner-aggregators">
                <div class="container">
                    <div class="row d-flex align-items-center">

                        <div class="col-md-6 col-sm-12 po-r">
                            <div class="banner-content">
                                <h4 class="display-6 b-title">Connecting Recruiters with
                                    Top Universities Worldwide</h4>
                                <div class="b-description">
                                    <p >GuideUni empowers recruiters with a robust platform designed to simplify university connections and streamline the student recruitment process. By joining our network, you gain access to powerful tools, comprehensive resources, and exclusive partnerships that help you connect students to the best global educational institutions.</p>
                                </div>


                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">


                        </div>
                    </div>
                </div>


            </div>
            <div class="banner-bottom">
                <div class="container-fluid">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 text-center banner-bottom-text">
                                Why Choose GuideUni?
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sectio-1">
                <ul>
                    <li>
                        <div class="container">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6 col-sm-12 sectio-1-title text-end">
                                    Affordable Access and Optional Upgrades
                                </div>
                                <div class="col-md-6 col-sm-12 sectio-1-description">
                                    <p>GuideUni offers a low processing fee to join the platform, with optional premium features available for advanced functionality. Customize your experience based on your recruitment goals and budget.</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="container">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6 col-sm-12 sectio-1-title text-end">
                                    Direct Access to Global Universities
                                </div>
                                <div class="col-md-6 col-sm-12 sectio-1-description">
                                    <p>Connect with a broad range of reputable universities across continents. Our platform ensures that you can match students with top institutions worldwide, enhancing your placement success rate.</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="container">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6 col-sm-12 sectio-1-title text-end">
                                    Application Tracking and CRM Integration
                                </div>
                                <div class="col-md-6 col-sm-12 sectio-1-description">
                                    <p>GuideUni provides advanced tools to monitor and manage each student’s application journey. From initial submission to final decision, stay updated with real-time tracking and integrate seamlessly with your CRM for efficient management.</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="container">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6 col-sm-12 sectio-1-title text-end">
                                    Enhanced Student Management
                                </div>
                                <div class="col-md-6 col-sm-12 sectio-1-description">
                                    <p>Use our platform to handle multiple applications, manage client interactions, and ensure smooth communication. GuideUni’s student management tools allow you to oversee every detail in one place.</p>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="container">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-6 col-sm-12 sectio-1-title text-end">
                                    Data Security and Compliance
                                </div>
                                <div class="col-md-6 col-sm-12 sectio-1-description">
                                    <p>We prioritize data protection, so your student information is always secure. GuideUni complies with international data standards, ensuring that you and your clients can operate with peace of mind.</p>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="k-features-section">
                <div class="container">
                    <div class="row">

                        <div class="col-md-6 col-sm-12 features-section-text" >
                            <h4>Key Features for Recruiters</h4>
                            <h5>Recruitment Dashboard</h5>
                            <p>Keep track of all applications in one place. The dashboard provides insights into student status, university responses, and upcoming deadlines, allowing you to stay organized and informed.</p>
                            <h5>Communication Tools</h5>
                            <p>Engage with universities and students using our integrated messaging system. Automated updates and reminders ensure that you and your clients never miss an important step in the process.</p>
                            <h5>Document Management</h5>
                            <p>Upload, review, and share documents securely. GuideUni’s document handling system streamlines the exchange of required materials, making it easy to complete applications efficiently.</p>
                            <h5>Performance Analytics</h5>
                            <p>Access detailed reports on your recruitment success rates, university partnerships, and application outcomes. Use data insights to refine your strategies and improve placement rates.</p>
                            <h5>Profile Customization</h5>
                            <p>Tailor your recruiter profile to showcase your expertise and unique offerings. Highlight your experience, achievements, and success stories to attract top university partnerships.</p>

                        </div>
                        <div class="col-md-6 col-sm-12" ></div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Aggregators;